import { Autocomplete, Box, Divider, useTheme, Checkbox, FormControlLabel, FormGroup, Grid, MenuItem, TextField, Typography, Button } from "@mui/material";
import { Elements, PaymentElement } from "@stripe/react-stripe-js";
import { loadStripe } from '@stripe/stripe-js';
import moment from 'moment';
import React, { useEffect, useState } from "react";
import helpers from "../../../Helpers/Helpers";
import Payment from "./Payment";

export default function PurchasePermits(props) {
  const theme = useTheme();
  const [pk, setPk] = useState();
  const [stripePromise, setStripePromise] = useState(null);

  useEffect(() => {
    setTimeout(() => {
      let org = props.org;
      if (org.payment_gateway == 'stripe') {
        let stripe_key = helpers.crypto_decrypt(org.stripe_publishable_key);
        setPk(stripe_key);
      }
    }, 5000);
  }, []);

  useEffect(() => {
    if (pk && !stripePromise) {
      setStripePromise(loadStripe(pk));
    }

  }, [pk, stripePromise]);

  const getPermitAmount = (amount) => {
    const includedTaxes = props.selectedZone.taxes?.filter(x=>x.tax_included);
    if(includedTaxes?.length){
      includedTaxes.map(x => {
        amount = amount - amount*x.tax_percentage/100;
      })
      return amount
    }else
    return amount
  }

  return (
    <Box component="form" onSubmit={props.purchaseParking} sx={{ p: 3, width: '100%' }}>
      {props.limitexceedMsg &&
        <Box sx={{ color: '#b20b01', border: '1px solid #b20b01', padding: '5px 15px', borderRadius: '20px', background: '#b20b0117', placeSelf: 'center', marginBottom: '15px' }}>
          <Typography variant='caption'>
            {props.limitexceedMsg}
          </Typography>
        </Box>}
      <Grid container spacing={3}>
        <Grid item md={6} sm={12} xs={12}>
          <Autocomplete
            options={props.zones}
            getOptionLabel={(option) => option.zone_name}
            value={props.selectedZone}
            onChange={(event, newValue) => props.onZoneSelected(newValue)}
            renderInput={(params) => (
              <TextField {...params} label={props.literals.select_zone} color="primary" size="small" required />
            )}
          />
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
          <TextField
            select
            label={props.literals.permit}
            color="primary"
            name="permit"
            value={props.selectedPermit}
            onChange={(e) => props.onPermitSelect(e.target.value)}
            InputLabelProps={{ shrink: (props.selectedPermit) ? true : false }}
            size="small"
            required
            fullWidth
          >
            {props.permits.map((x) => {
              return (
                <MenuItem value={x}>{x.permit_name}</MenuItem>
              )
            })}
          </TextField>
        </Grid>
        {props.selectedPermit && props.selectedPermit?.permit_type !== 'custom' && <Grid item md={6} sm={12} xs={12}>
          <TextField
            select
            disabled={props.permitVal.sold_out}
            label={props.selectedPermit?.permit_type == 'monthly' ? props.literals.select_month : props.literals.select_year}
            color="primary"
            name="no_of_months_year"
            value={props.inputField['no_of_months_year']}
            onChange={(e) => props.onMonthYearSelect(e.target.value)}
            size="small"
            required
            fullWidth
          >
            {props.noOfMonthYear.map((x) => {
              return (
                <MenuItem value={x.value}>{x.label}</MenuItem>
              )
            })}
          </TextField>
        </Grid>}
        <Grid item md={6} sm={12} xs={12}>
          <TextField
            label={props.literals.plate}
            color="primary"
            name="plate"
            value={props.inputField['plate']}
            onChange={props.handleChange}
            InputLabelProps={{ shrink: (props.inputField['plate']) ? true : false }}
            size="small"
            required
            fullWidth
          >
          </TextField>
        </Grid>
        {props.selectedPermit && props.selectedPermit?.permit_type !== 'custom' && <Grid item xs={12}>
          <FormGroup>
            <FormControlLabel control={
              <Checkbox
                name="allow_auto_renew"
                onChange={props.handleCheck}
                checked={props.inputField['allow_auto_renew']}
                disabled={props.permitVal?.auto_renew_permission == 'restrict_auto_renew'}
              />} label={
                <Typography variant="subtitle1" color="primary" className="font-gray">
                  {props.literals.allow_auto_renew}
                </Typography>
              } />
          </FormGroup>
        </Grid>}
        {props.selectedPermit && <Grid item xs={12} sx={{ alignSelf: 'center' }}>
          <Box sx={{ width: '100%', p: 2, background: '#f8f8f8' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', color: 'black' }}>
              <Typography variant='caption' align='left' sx={{ color: 'primary.main' }} >
                {props.permitVal.from}
              </Typography>
              {props.inputField['allow_auto_renew'] &&
                <Typography variant="caption" color={'primary'} className="font-bold">
                  {props.literals.permit_will_renew_on}: {props.permitVal.next_renew_at}
                </Typography>
              }
            </Box>
            <Divider />
            <Box sx={{ display: 'flex', marginTop: 2, justifyContent: 'space-between', alignItems: 'flex-end', color: 'black' }}>
              <Typography variant='caption' align='left' sx={{ color: 'primary.main' }} >
                {props.literals.parking_session_end_at}
              </Typography>
              <Typography variant='caption' align='left'
                sx={{ background: theme.palette.primary.main, color: '#FFF', padding: '0 23px', borderRadius: '17px' }}
              >
                {props.permitVal.end_on}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', marginTop: 2, justifyContent: 'space-between', alignItems: 'flex-end', color: 'black' }}>
              <Typography variant='subtitle1' align='left' sx={{ color: 'primary.main' }} >
                {moment(props.permitVal.to, "MMMM Do YYYY, hh:mm a").format("MMM Do YYYY")}
              </Typography>
              <Typography variant='h4' align='left' sx={{ color: 'primary.main' }} >
                {moment(props.permitVal.to, "MMM Do YYYY, hh:mm a").format("hh:mm a")}
              </Typography>
            </Box>
          </Box>
          {!!props.selectedZone.taxes?.length && <Box sx={{ display: 'flex', width: '100%', marginTop: 2, justifyContent: 'space-between', alignItems: 'flex-end', color: 'black' }}>
            <Typography variant='caption' align='left' sx={{ color: 'primary.main' }} >
              {props.literals.amount}
            </Typography>
            <Typography variant='caption' align='left' sx={{ color: 'primary.main' }} >
              CA${(getPermitAmount(props.permitVal.rate) / 100).toFixed(2)}
            </Typography>
          </Box>}
          {props.selectedZone.taxes?.map(x => {
            return (
              <Box sx={{ display: 'flex', width: '100%', marginTop: 2, justifyContent: 'space-between', alignItems: 'flex-end', color: 'black' }}>
                <Typography variant='caption' align='left' sx={{ color: 'primary.main' }} >
                  {x.tax_name}
                </Typography>
                <Typography variant='caption' align='left' sx={{ color: 'primary.main' }} >
                  CA${((props.permitVal.rate*x.tax_percentage/100) / 100).toFixed(2)}
                </Typography>
              </Box>
            )
          })}
          <Divider sx={{ width: '100%' }} />
          <Box sx={{ display: 'flex', width: '100%', marginTop: 2, justifyContent: 'space-between', alignItems: 'flex-end', color: 'black' }}>
            <Typography variant='caption' align='left' sx={{ color: 'primary.main' }} >
              {props.literals.total_amount}
            </Typography>
            <Typography variant='caption' align='left' sx={{ color: 'primary.main' }} >
              CA${(props.getTotalAmount(props.permitVal.rate, props.selectedZone.taxes) / 100).toFixed(2)}
            </Typography>
          </Box>
          {/* <Box sx={{ display: 'flex', width: '80%', marginTop: 2, justifyContent: 'space-between', alignItems: 'flex-end', color: 'black' }}>
            <Typography variant='caption' align='left' sx={{ color: 'primary.main' }} >
              {props.literals.service_fee}
            </Typography>
            <Typography variant='caption' align='left' sx={{ color: 'primary.main' }} >
              CA${(props.permitVal.rate / 100).toFixed(2)}
            </Typography>
          </Box> */}
          <Box sx={{ width: '80%', my: 1, justifySelf: 'center' }}>
            {!props.showPayment &&
              <Button
                type='submit'
                size='large'
                variant='contained'
                disabled={props.permitVal.sold_out}
                sx={{ borderRadius: 8, width: '100%', my: 2 }}
              >
                ${(props.getTotalAmount(props.permitVal.rate, props.selectedZone.taxes) / 100).toFixed(2)}
              </Button>}
            {props.showPayment &&
              <Elements stripe={stripePromise} options={{
                clientSecret: props.paymentIntent.client_secret,
              }}>
                <Payment
                  permitVal={props.permitVal}
                  totalAmount={props.getTotalAmount(props.permitVal.rate, props.selectedZone.taxes)}
                  inputField={props.inputField}
                  org={props.org}
                  paymentIntent={props.paymentIntent}
                  selectedZone={props.selectedZone}
                  showReciept={props.showReciept}
                  setParking={props.setParking}
                />
              </Elements>
            }
          </Box>
        </Grid>}
      </Grid>
    </Box>
  );
}